import { render, staticRenderFns } from "./AffiliateVideosPage.vue?vue&type=template&id=21e95e70&"
import script from "./AffiliateVideosPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateVideosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports